import { Box } from '@chakra-ui/react'
import { mdiMessageQuestionOutline } from '@mdi/js'
import Icon from '@mdi/react'

import useColorModeValue from '@/hooks/useColorModeValue'
import { TIntegratedSystems } from '@/types/tasksApprovals'

import { widgetsConfig } from '../../config'

const SystemIcon = ({ system, size, color }: { system: TIntegratedSystems; size?: string; color?: string }) => {
    const widgetsSettings = widgetsConfig(system)
    const iconColor = useColorModeValue(
        `var(--chakra-colors-widgets-${system.toLowerCase()}-light)`,
        `var(--chakra-colors-widgets-${system.toLowerCase()}-dark)`,
    )
    const missingSystemColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')
    const defaultIconColor = widgetsSettings.id !== 'DEFAULT' ? iconColor : missingSystemColor

    return (
        <Box transform={system === 'FIELDGLASS_TIMESHEET' ? 'rotate(315deg)' : ''}>
            <Icon
                path={widgetsSettings.icon.name ?? mdiMessageQuestionOutline}
                size={size ?? '24px'}
                color={color === 'default' || !color ? defaultIconColor : color}
            />
        </Box>
    )
}

export default SystemIcon
